const themeConfig = {
	googleFonts: "Open+Sans:ital,wght@0,400;0,600;1,400;1,600",
	shape: {
		borderRadius: 3,
	},
	breakpoints: {
		keys: ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"],
		values: {
			xxs: 0,
			xs: 620,
			sm: 800,
			md: 1100,
			lg: 1270,
			xl: 1420,
			xxl: 1536,
		},
		unit: "px",
	},
	palette: {
		body: {
			main: "#f5f5f5",
			light: "#ffffff",
			dark: "#e0e0e0",
			contrastText: "#000000",
		},
		appBar: {
			public: {
				main: "#FFFFFF",
				light: "#FFFFFF",
				dark: "#FFFFFF",
				contrastText: "#2C2C6D",
			},
			private: {
				main: "#FFFFFF",
				light: "#FFFFFF",
				dark: "#FFFFFF",
				contrastText: "#2C2C6D",
			},
		},
		titleBar: {
			public: {
				main: "#2C2C6D",
				light: "#2C2C6D",
				dark: "#2C2C6D",
				contrastText: "#ffffff",
				gradient: `url('/texture.png'), linear-gradient(90deg, #2b2c6d 30%, #0d8bb1)`,
			},
		},
		primary: {
			main: "#2C2C6D",
			light: "#2C2C6D",
			dark: "#2C2C6D",
		},
		secondary: {
			main: "#B8A57A",
			light: "#B8A57A",
			dark: "#B8A57A",
		},
		underline: {
			main: "#B8A57A",
		},
		footer: {
			main: "#1E1E1E",
			light: "#313131",
			dark: "#191919",
		},
		link: {
			main: "#016197",
			light: "#0472b0",
			dark: "#00466e",
		},
		excerptLink: {
			main: "#000000",
			light: "#000000",
			dark: "#000000",
		},
		excerptUnderline: "#B8A57A",
		sidebarUnderline: "#B8A57A",
		tab: {
			main: "#2C2C6D",
			contrastText: "#ffffff",
		},
		highlight: {
			light: "rgba(255, 255, 255, 0.85)",
		},
	},
	typography: {
		fontSize: 16,
		fontFamily: [
			"Open Sans",
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		subtitle2: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			opacity: 1,
			color: "#000000",
		},
		h1: {
			fontFamily: "Open Sans",
			fontWeight: 400,
			fontSize: "2rem",
		},
		h2: {
			fontWeight: 600,
			fontSize: "1.8rem",
		},
		h3: {
			fontWeight: 600,
			fontSize: "1.6rem",
		},
		h4: {
			fontWeight: 600,
			fontSize: "1.4rem",
		},
		h5: {
			fontWeight: 600,
			fontSize: "1.2rem",
		},
		h6: {
			fontWeight: 600,
			fontSize: "1rem",
		},
		fontWeightBold: 600,
		titleBar: {
			fontFamily: "Open Sans",
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.3rem",
		},
	},
	customOptions: {
		flush: true,
		navbarAlign: "right",
		sidebarStyle: "box",
	},
	globalSearch: {
		thumbnailOrientation: "square",
		hideFilterByType: true,
		hideDateFilters: true,
	},
	cloverleaf: {
		footer: {
			maxCols: 5,
		},
	},
};
module.exports = themeConfig;
